//@ts-nocheck
const normalizeBoolean = (value) =>
  value === true || String(value).toLowerCase() === 'true';

export const selectPassengerSignedDocumentGenerateEndpoint = ({
  bookingpassengerid,
  passengerkey
} = {}) => {
  if (bookingpassengerid) {
    return 'by-id';
  }

  if (passengerkey) {
    return 'by-key';
  }

  return null;
};

export const mapSignedDocumentGenerateResponse = (response = {}) => {
  const documentState = response?.data?.data ?? response?.data ?? null;

  if (!documentState) {
    return {
      documentState: null,
      documentReady: false,
      token: null,
      externalSignedDocumentId: null
    };
  }

  return {
    documentState,
    documentReady: normalizeBoolean(
      documentState?.documentReady ?? documentState?.documentready
    ),
    token: documentState?.token || null,
    externalSignedDocumentId:
      documentState?.externalSignedDocumentId ||
      documentState?.externalsigneddocumentid ||
      null
  };
};
